import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

export type RatingSource = 'google' | 'swiggy' | 'zomato';
export type RatingSeverity =
  | 'severe'
  | 'mild'
  | 'stable'
  | 'improving'
  | 'unknown';

export interface RatingTrendRow {
  outlet_id: string;
  source: RatingSource;
  current_rating: number | null;
  rating_7d_ago: number | null;
  rating_28d_ago: number | null;
  delta_7d: number | null;
  delta_28d: number | null;
  last_snapshot_at: string | null;
  review_count: number | null;
  severity: RatingSeverity;
}

/**
 * Per-(outlet, source) current rating with 7d + 28d ago comparisons.
 * Drives the rating drop detection table on /reviews and feeds Active Fires.
 */
export function useRatingTrends() {
  return useQuery({
    queryKey: ['rating-trends'],
    queryFn: async (): Promise<RatingTrendRow[]> => {
      const { data, error } = await marketing
        .from('outlet_rating_trend')
        .select('*');
      if (error) throw error;
      return (data ?? []) as unknown as RatingTrendRow[];
    },
    staleTime: 60_000,
  });
}
